import { FinanceProgramType, MarkupType, SubsidyCapType } from '@trnsact/trnsact-shared-types';
import { FinanceProgramForm } from '../schema';
import { Fee, MarkupMethods, Structures } from '../types';

export function mapConfigurationFormValuesToCreateOrUpdate(formValue: FinanceProgramForm) {
  const {
    program: { first, second },
  } = formValue;

  const result: any = {
    notes: first.details.notes,
    type: second.programType,
    rateType: second.rateType,
    guidelines: first.details.guidelines,
    customerRate: second.customerRate,
    dealerMarkup: second.dealerMarkup,
    financeProgramName: first.details.displayName,
    paymentPeriodTiming: second.paymentCalculationMethod,
    daysToFirstPayment: Number(second.daysToFirstPayment),
    numberOfAdvancePayments: Number(second.advancePayment),
    minimumRequiredDownPayment: second.minimumRequiredDownPayment,
    residualPercentage: second.programType === FinanceProgramType.Lease ? second.residual : undefined,
    terms: second.terms.map((term, index) => ({
      term: Number(term),
      rate: second.isSpecifyRate ? second.specifyRates[index].rate : second.rate,
    })),
    subsidyPercent: second.subsidyPercent,
    dnetPercent: second.dnetPercent,
    flatFees: second.fee.filter(fee => fee.type === MarkupType.Flat).map(mapFeeValue),
    percentageFees: second.fee.filter(fee => fee.type === MarkupType.Percentage).map(mapFeeValue),
    markups: [],
    isSubsidized: second.structure === Structures.Subsidy,
    subsidyCapConfiguration: { ...second.subsidyCapConfiguration, lenderMarketRates: second.specifyLenderMarketRates },
    linkToLenderCreditApp: first.details.linkToLenderCreditApp,
    isTiersEnabled: second.isTiersEnabled,
  };

  if (second.structure !== Structures.Subsidy || !second.configureSubsidyCap) {
    delete result.subsidyCapConfiguration;
  }

  if (result.subsidyCapConfiguration && result.subsidyCapConfiguration.subsidyCapType === SubsidyCapType.FixedAmount) {
    delete result.subsidyCapConfiguration.netInvoicePercentage;
  }

  if (
    result.subsidyCapConfiguration &&
    result.subsidyCapConfiguration.subsidyCapType === SubsidyCapType.NetInvoicePercentage
  ) {
    delete result.subsidyCapConfiguration.maxSubsidyAmount;
  }

  if (second.structure === Structures.None) {
    delete result.dealerMarkup;
    delete result.customerRate;
  }

  if (second.structure === Structures.Subsidy) {
    delete result.dealerMarkup;
  }

  if (second.structure === Structures.Markup) {
    if (second.method === MarkupMethods.Markup) {
      delete result.customerRate;
    }

    if (second.method === MarkupMethods.CustomerRate) {
      delete result.dealerMarkup;
    }
  }

  return result;
}

const mapFeeValue = ({ amount, isFinanced, description }: Fee) => ({
  fee: amount,
  financed: isFinanced,
  identifier: description,
});
